import { isAndroid } from './BrowserHelpers';

export const DOWNLOAD_WARNING = 'While this file is encrypted during transmission, once downloaded, you are responsible for implementing appropriate safeguards to protect the data, including encryption or deletion to the extent required by applicable law.'; // eslint-disable-line max-len

export function handleDownloadClick(attachmentUrl, fileName, isNativeApp, isLightbox) {
  const response = !isLightbox ? window.confirm(DOWNLOAD_WARNING) : true; // eslint-disable-line no-alert

  if (response === true) {
    const link = document.createElement('a');

    link.setAttribute('href', attachmentUrl);
    const isAndroidApp = isNativeApp && isAndroid();
    if (!isAndroidApp) {
      link.setAttribute('target', '_blank');
    }
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
